import Home from './containers/Home';

export default Home;
